import React, { Component } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import Loadable from 'react-loadable';
import './App.scss';
import './appStyle.css';

import axios from './medisource/http'; // this is required to handle request
import AuthService from './medisource/AuthService'
// import { AppFooter } from '@coreui/react';

/* Toastify */
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/* FullCalendar */
import 'fullcalendar-reactwrapper/dist/css/fullcalendar.min.css';
import 'react-month-picker-input/dist/react-month-picker-input.css';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Containers
const DefaultLayout = Loadable({
  loader: () => import('./containers/DefaultLayout'),
  loading
});

// Pages
const Login = Loadable({
  loader: () => import('./views/Pages/Login'),
  loading
});

const Register = Loadable({
  loader: () => import('./views/Pages/Register'),
  loading
});

const Page404 = Loadable({
  loader: () => import('./views/Pages/Page404'),
  loading
});

const Page500 = Loadable({
  loader: () => import('./views/Pages/Page500'),
  loading
});

const Demo = Loadable({
  loader: () => import('./views/Pages/Demo'),
  loading
});


const HEALTHY = Loadable({
  loader: () => import('./views/Healthz/healthz'),
  loading
});



class App extends Component {

  render() {
    console.log(localStorage.getItem("api_token"))

    var auth_service = new AuthService();
      auth_service.verifyToken()
        .then(isVerified => {

          console.log("IS TOKEN VERIFIED?", isVerified);
          // console.log(window.location.pathname)

          if (isVerified === false && ["/login", "/demo-request", "/healthz"].indexOf(window.location.pathname) === -1) {
            window.location.href="/login";
          }
          
        });

    return (
      <div>
        <ToastContainer position="bottom-left" />
        <BrowserRouter>
          <Switch>
            <Route exact path="/login" name="Login Page" component={Login} />
            <Route exact path="/register" name="Register Page" component={Register} />
            <Route exact path="/404" name="Page 404" component={Page404} />
            <Route exact path="/500" name="Page 500" component={Page500} />
            <Route exact path="/demo-request" name="Demo Request" component={Demo} />
            <Route exact path="/healthz" name="HEALTHY" component={HEALTHY} />
            <Route path="/" name="Home" component={DefaultLayout} />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
